export default __webpack_public_path__ + "static/media/leviathan.75f5bf2a.png";